import { useTranslation } from 'react-i18next';

const I18nWrapper = ({ children }) => {
  const { ready } = useTranslation();

  if (!ready) {
    return (
      <div className="min-h-screen bg-navy flex items-center justify-center">
        <div className="text-accent font-mono text-lg">Loading...</div>
      </div>
    );
  }

  return children;
};

export default I18nWrapper;